import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessage = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.39453 14.0312C4.85156 13.6797 5.44922 13.6094 5.97656 13.7852C6.89062 14.1367 7.94531 14.3125 9.07031 14.3125C13.4297 14.3125 16.3828 11.5 16.3828 8.6875C16.3828 5.91016 13.4297 3.0625 9.07031 3.0625C4.67578 3.0625 1.75781 5.91016 1.75781 8.6875C1.75781 9.8125 2.17969 10.9023 2.98828 11.8516C3.30469 12.168 3.44531 12.625 3.41016 13.082C3.375 13.7148 3.19922 14.3125 3.02344 14.8398C3.62109 14.5586 4.11328 14.2422 4.39453 14.0312ZM0.808594 15.4375C0.878906 15.3672 0.914062 15.2617 0.984375 15.1562C1.33594 14.5938 1.65234 13.8203 1.72266 12.9414C0.667969 11.7461 0.0703125 10.3047 0.0703125 8.6875C0.0703125 4.67969 4.07812 1.375 9.07031 1.375C14.0273 1.375 18.0703 4.67969 18.0703 8.6875C18.0703 12.7305 14.0273 16 9.07031 16C7.73438 16 6.50391 15.7891 5.37891 15.4023C4.99219 15.6836 4.28906 16.1055 3.48047 16.457C2.95312 16.7031 2.35547 16.9141 1.72266 17.0195C1.6875 17.0195 1.65234 17.0547 1.65234 17.0547C1.47656 17.0898 1.33594 17.0898 1.16016 17.125C0.984375 17.125 0.808594 17.1602 0.597656 17.1602C0.386719 17.1602 0.175781 17.0195 0.105469 16.8086C0 16.5977 0.0703125 16.3516 0.210938 16.1758C0.351562 16.0352 0.492188 15.8945 0.597656 15.7188C0.667969 15.6133 0.738281 15.543 0.773438 15.4727C0.773438 15.4727 0.773438 15.4727 0.773438 15.4375H0.808594Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgMessage);
export { ForwardRef as ReactComponent };
